import { render, staticRenderFns } from "./TrafficStatisticChart.vue?vue&type=template&id=799049a0&scoped=true&"
import script from "./TrafficStatisticChart.vue?vue&type=script&lang=ts&"
export * from "./TrafficStatisticChart.vue?vue&type=script&lang=ts&"
import style0 from "./TrafficStatisticChart.vue?vue&type=style&index=0&id=799049a0&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "799049a0",
  null
  
)

export default component.exports